import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Typography } from '@mui/material';
import React from 'react';
export function showDeleteDialog({ t, functionClient, file, onSuccess }) {
    const fileEntityType = file.columns.directory ? t('common.folder') : t('common.file');
    showConfirmDialog({
        title: t('deleteDialog.title', { fileName: file.columns.name }),
        content: (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle, "data-test": 'confirm-delete-message' }, t('deleteDialog.description'))),
        confirmLabel: t('deleteDialog.submitButtonLabel'),
        onConfirm: () => {
            functionClient
                .executeFunction({ functionName: 'deleteFile', params: { fileId: file.id } })
                .then(() => {
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    autoHideDuration: 2000,
                    verticalPosition: 'bottom',
                    message: t('deleteDialog.archivedSnackbar', { fileEntityType }),
                });
                onSuccess();
            })
                .catch(handleErrorDialog);
        },
    });
}
